export default "__VITE_ASSET__38efd171__"